import * as echarts from 'echarts/core';
import {
  BarChart,
  CustomChart,
  FunnelChart,
  HeatmapChart,
  LineChart,
  GaugeChart,
  MapChart,
  PictorialBarChart,
  PieChart,
  SankeyChart,
  ScatterChart,
  TreemapChart,
} from 'echarts/charts';
import {
  GeoComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  PolarComponent,
  TooltipComponent,
  VisualMapContinuousComponent,
} from 'echarts/components';
import { LabelLayout } from 'echarts/features';
import { SVGRenderer } from 'echarts/renderers';

// Only what Studio's charts draw, so the bundle carries nothing else. SVG,
// not canvas: the scheduled-report renderer waits on the page's svg paths,
// prints stay sharp, and jsdom can render it in tests.
echarts.use([
  BarChart,
  // A Bullet's rows (see toBulletOption)
  CustomChart,
  FunnelChart,
  HeatmapChart,
  LineChart,
  GaugeChart,
  MapChart,
  PictorialBarChart,
  PieChart,
  SankeyChart,
  ScatterChart,
  TreemapChart,
  GeoComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  PolarComponent,
  TooltipComponent,
  VisualMapContinuousComponent,
  // A series' labelLayout (e.g. a pie hiding its overlapping labels, as the
  // Highcharts pie does) does nothing without it
  LabelLayout,
  SVGRenderer,
]);

export default echarts;
